function InputGroup({ label, name, id, type = "text", value, onChange }) {
  return (
    <div className="input-group">
      <label htmlFor={id}>{label}</label>
      <input 
        type={type} 
        name={name} 
        id={id} 
        value={value} 
        onChange={onChange} 
      />
    </div>
  );
}

export default InputGroup;
